import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCorreoPedido } from '../../actions/pedidos'
import { LONG_PEDIDO } from '../../helpers/longitudesPedido'
import i18n from '../../lang/idiomas'

const CorreoPedido = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const pedido = useSelector(state => state.pedidos.pedido)
  const [error, setError] = useState('')

  const validarCorreos = valor => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return valor.split(',').every(c => regex.test(c.trim()))
  }

  function handleChange(event) {
    const valor = event.target.value
    if (valor && !validarCorreos(valor)) {
      setError(i18n.t('correo.correrr', 'Introduce correos válidos separados por comas'))
    } else {
      setError('')
    }
    dispatch(setCorreoPedido(valor))
  }

  // Valor inicial: email del usuario si reservado_alfa_3 está vacío
  const valor = pedido?.reservado_alfa_3 ?? ''

  return (
    <form className='form-default'>
      <div className='form-group'>
        <label htmlFor='correo_pedido'>{i18n.t('general.corlabel', 'CORREO *')}</label>
        <input
          className={`form-control${error ? ' is-invalid' : ''}`}
          type='text'
          onChange={handleChange}
          name='correo_pedido'
          id='correo_pedido'
          value={valor}
          placeholder='correo@ejemplo.com, otro@ejemplo.com'
          maxLength={LONG_PEDIDO.reservado_alfa_3}
          required
          disabled={pedidoGuardado || pedido_cargando}
        />
        {error && <div className='invalid-feedback'>{error}</div>}
      </div>
    </form>
  )
}

export default CorreoPedido
